export const SET_ASSETS_TO_DOWNLOAD = 'SET_ASSETS_TO_DOWNLOAD';
